"use client";
import dynamic from "next/dynamic";
import { ToolSkeleton } from "@/components/ui/ToolSkeleton";

const ImageMirrorClient = dynamic(() => import("./ImageMirrorClient"), {
  ssr: false,
  loading: () => <ToolSkeleton />,
});

export default function ImageMirrorClientWrapper() {
  return <ImageMirrorClient />;
}
